<div class="fixed-min-header-height px-4 main-bg-color">


    <ul class="breadcrumbs d-flex pt-5">
        <li>
            <a routerLink="/" title="Home">Home</a>
        </li>
        <li>
            <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
        </li>
        <li>
            <a [routerLink]="['/mycart/']" title="My cart">My Cart</a>
        </li>
        <li>
            <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
        </li>
        <li>
            Order Summary
        </li>
    </ul>

    <a href="javascript:void(0);" [routerLink]="['/mycart/review/']" title="back"
        class="back-listing-btn d-none d-lg-block back-cart">
        <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Combined Shape</title>
            <desc>Created with Sketch.</desc>
            <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C"
                    fill-rule="nonzero">
                    <path
                        d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z"
                        id="Combined-Shape"></path>
                </g>
            </g>
        </svg> Back </a>

    <div class="main-bg">
        <div class="col-12 fixed-width-right-column hide-accordion-heading p-0 order-scroll order-summory-left">


            <div class="order-detail-main" *ngIf="componentLoaded && productList?.length >0">

                <div class="header-order">
                    <h3 class="col-md-10">Order Summary</h3>

                    <div class="col-md-2">{{productList?.length}} Products</div>
                </div>

                <div class="iner-order-detail" id="productcart_{{product.product_id}}"
                    *ngFor="let product of productList">
                    <div class="image-box">
                        <a javascript="void(0)">
                            <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                        </a>
                    </div>


                    <div class="order-summary-right">
                        <div class="title-main">
                            <h5>{{product.short_desc}}</h5>
                            <ul class="product-code">
                                <li>{{product.barcode}}</li>
                                <li class="seperator">|</li>
                                <li>{{product.sku}}</li>
                            </ul>
                        </div>

                        <div class="rsp">
                            <div class="small-title">RSP</div>
                            <p> <span class="black-big" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                <span class="black-big " *ngIf="product.rsp == '0.00'">N/A</span>
                                <span class="font-14"
                                    *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))"
                                    class="each">per 100g</span>
                                <span class="font-14"
                                    *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)"
                                    class="each">each</span>
                            </p>
                        </div>

                        <div class="rsp" *ngIf="global_data?.margin_visibility == 1">
                            <div class="small-title">Margin</div>
                            <span class="black-big">{{product.margin}}%</span>
                        </div>


                        <div class="rsp" *ngIf="global_data?.price_visibility == 1">
                            <div class="small-title">Cost</div>
                            <div class="black-big">£{{product.price}}</div>
                        </div>

                        <div class="small-rsp">
                            <div class="small-title">Case</div>
                            <div class="black-big">{{product.size_case}}</div>
                        </div>

                        <div class="small-rsp">
                            <div class="small-title">Quantity</div>
                            <div class="black-big">{{product.item_qty !='' ? toInteger(product.item_qty) : 1}}</div>
                        </div>

                        <div class="small-rsp" *ngIf="global_data?.price_visibility == 1">
                            <div class="small-title"></div>
                            <div class="black-big">£{{product.row_total}}</div>
                        </div>
                    </div>
                </div>
                <div class="view-all-order d-flex"
                    *ngIf="(this.nextPage != 1 && this.nextPage !== null) && !this.loading"><a
                        href="javascript:void(0);" (click)="onScrollDown()" title="View More"
                        class="btn primary-btn">View More</a></div>

            </div>


            <div class="no-order-summory" *ngIf="componentLoaded && productList?.length == 0">
                <diV class="w-100 text-center">
                    <img src="../../../../assets/images/no-order-summory.svg" alt="">
                </diV>
                <button class="btn primary-btn" [routerLink]="['/']">Go to Home</button>
            </div>

        </div>
        <div class=" pr-0 col-12 fixed-width-left-column  order-summory-right mt-2" *ngIf="productList?.length >0">
            <div class="order-detail-rig" *ngIf="orderDetail.items_count != '0'">
                <div class="header-order-right">
                    Order Details
                </div>

                <div class="order-detail-botto">

                    <div class="row ">
                        <div class="col-md-6">
                            <div class="small-title" *ngIf="orderDetail.items_count == '1'"> Item</div>
                            <div class="small-title" *ngIf="orderDetail.items_count != '1'"> Items</div>
                            <div class="black-big"> {{orderDetail.items_count}}</div>
                        </div>

                        <div class="col-md-6">
                            <div class="small-title" *ngIf="orderDetail.items_qty == '1'"> Case</div>
                            <div class="small-title" *ngIf="orderDetail.items_qty != '1'"> Cases</div>
                            <div class="black-big"> {{orderDetail.items_qty}}</div>
                        </div>
                    </div>


                    <div class="row  mt-4">

                        <div class="col-md-6">
                            <div class="small-title">Payment Mode</div>
                            <div class="black-big">{{global_data.payment_mode}}</div>
                        </div>
                    </div>
                    <div class="product-detail"
                        *ngIf="orderDetail.is_discount == '1' && orderDetail.free_products.length > 0">
                        <div class="total-amount-box mt-3">
                            <div class="amount-left">Net Amount:</div>
                            <div class="amount-price" *ngIf="orderDetail.cart_total != undefined">
                                £{{orderDetail.cart_total.subtotal}}</div>
                        </div>

                        <div class="promotion-listing total-amount-box"
                            *ngIf='orderDetail.promotions != undefined && orderDetail.promotions.length != 0'>
                            <h5>
                                Promotion:
                            </h5>
                            <ul>
                                <li *ngFor="let pro of orderDetail.promotions">
                                    <p>{{pro.name}}</p><span class="red" *ngIf=" global_data?.price_visibility == 1">
                                        -£{{pro.discount}}</span>
                                </li>
                            </ul>
                        </div>

                        <div class="total-amount-box"
                            *ngIf=" orderDetail?.cart_total != undefined &&  global_data?.price_visibility == 1 && (orderDetail?.cart_total?.store_discount != '' && orderDetail?.cart_total?.store_discount > 0)">
                            <div class="amount-left">
                                Discount Applied:
                            </div>
                            <div class="amount-price">- £{{orderDetail.cart_total.store_discount}}</div>
                        </div>


                        <div class="total-amount-box" *ngIf=" global_data?.price_visibility == 1 && global_data?.vat_exempt == 0">
                            <div class="amount-left">VAT:</div>
                            <div class="amount-price" *ngIf="orderDetail.cart_total != undefined ">
                                £{{orderDetail.cart_total.vat}}</div>
                        </div>


                        <div class="total-amount-box" *ngIf=" global_data?.price_visibility == 1">
                            <div class="amount-left">Total Amount:</div>
                            <div class="amount-price" *ngIf="orderDetail.cart_total != undefined">
                                £{{orderDetail.cart_total.grand_total}}</div>
                        </div>

                    </div>
                </div>
                <div class="available-offers" *ngIf="promotionMessage?.length > 0">
                    <h4>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21">
                            <g fill="none" fill-rule="evenodd">
                                <g fill="#D9394C" fill-rule="nonzero">
                                    <g>
                                        <path
                                            d="M28.734 15.553c1.18-.737 2.676-.737 3.856 0 .428.271.929.401 1.434.373l.021-.001c1.39-.073 2.7.656 3.331 1.859l.007.013c.229.432.59.779 1.031.99l.012.005c1.254.61 2.014 1.88 1.937 3.237l-.001.02c-.026.478.107.95.378 1.345.779 1.137.779 2.636 0 3.773-.272.395-.404.868-.378 1.346v.018c.078 1.357-.682 2.627-1.935 3.237l-.01.005c-.444.212-.807.56-1.037.995-.636 1.212-1.944 1.941-3.335 1.868l-.02-.001c-.506-.029-1.007.102-1.435.372-1.18.738-2.676.738-3.856 0-.427-.27-.929-.4-1.434-.372h-.021c-1.393.074-2.7-.655-3.331-1.858l-.005-.01c-.229-.433-.591-.782-1.033-.993l-.013-.006c-1.254-.61-2.013-1.88-1.936-3.236l.001-.02c.026-.478-.107-.95-.377-1.345-.78-1.137-.78-2.637 0-3.774.27-.395.403-.867.377-1.345v-.019c-.078-1.357.682-2.627 1.935-3.236l.012-.006c.443-.212.805-.56 1.034-.995l.005-.009c.632-1.202 1.94-1.932 3.33-1.858h.022c.505.03 1.006-.101 1.434-.372zm3.232.99c-.798-.499-1.81-.499-2.608 0-.632.401-1.374.594-2.121.552l-.02-.001c-.934-.05-1.813.435-2.233 1.234l-.006.011c-.345.655-.892 1.182-1.56 1.502l-.01.005c-.815.382-1.32 1.217-1.278 2.116v.02c.04.737-.164 1.467-.582 2.075-.506.737-.506 1.709 0 2.445.417.609.622 1.338.582 2.075v.021c-.052.884.45 1.715 1.278 2.117l.011.005c.667.32 1.213.846 1.558 1.5l.006.011c.44.812 1.312 1.294 2.233 1.236l.021-.001c.066-.004.133-.006.199-.006.68 0 1.347.193 1.922.557.798.499 1.81.499 2.608 0 .632-.4 1.374-.593 2.121-.551h.02c.935.05 1.813-.434 2.233-1.233.35-.666.898-1.193 1.566-1.514.837-.406 1.339-1.237 1.288-2.12v-.02c-.04-.738.164-1.467.582-2.076.505-.737.506-1.708 0-2.445-.418-.608-.623-1.338-.583-2.075l.001-.02c.051-.885-.451-1.715-1.279-2.117l-.01-.005c-.667-.32-1.213-.846-1.559-1.5l-.007-.015c-.419-.797-1.294-1.281-2.232-1.232l-.02.001c-.747.041-1.489-.151-2.12-.551zm1.943 9.669c1.022 0 1.85.828 1.85 1.85 0 1.023-.828 1.851-1.85 1.851-1.023 0-1.851-.828-1.851-1.85 0-1.023.828-1.851 1.85-1.851zm1.167-5.134c.183.184.204.469.061.675l-.061.073-7.404 7.404c-.206.206-.541.206-.748 0-.183-.184-.204-.469-.061-.675l.061-.073 7.404-7.404c.206-.207.541-.207.748 0zm-1.167 6.191c-.438 0-.794.355-.794.794 0 .438.356.793.794.793.438 0 .793-.355.793-.794 0-.438-.355-.793-.793-.793zm-5.818-6.875c1.023 0 1.851.829 1.851 1.851s-.828 1.851-1.85 1.851c-1.023 0-1.852-.829-1.852-1.85 0-1.023.83-1.852 1.851-1.852zm0 1.058c-.438 0-.793.355-.793.793 0 .438.355.793.793.793.438 0 .794-.355.794-.793 0-.438-.356-.793-.794-.793z"
                                            transform="translate(-1635.000000, -984.000000) translate(1615.000000, 969.000000)" />
                                    </g>
                                </g>
                            </g>
                        </svg> Available Offers
                    </h4>
                    <ul [ngClass]="promotionMessage?.length == 1 ? 'show' : ''" [class.show]="show">
                        <li *ngFor="let offer of promotionMessage"
                            [ngClass]="offer.hyperlink == '' ? '' : 'offer-hyperlink'">
                            {{offer.message}} <span>{{offer.key}}</span><span *ngIf="offer.hyperlink != ''"><a
                                    href="javascript:void(0);"
                                    (click)="redirectTo(offer)">{{offer.hyperlink}}</a></span>
                        </li>
                    </ul>
                    <button class="show-more-btn" (click)="show = !show" [class.show]="show"
                        *ngIf="promotionMessage?.length > 1">{{ show ? 'Show less': 'Show More' }}

                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7">
                            <g fill="none" fill-rule="evenodd">
                                <g fill="#D9394C" fill-rule="nonzero">
                                    <g>
                                        <g>
                                            <path
                                                d="M89 9.47L90.061 10.53 84.53 16.061 79 10.53 80.061 9.47 84.53 13.939z"
                                                transform="translate(-1714.000000, -1164.000000) translate(1615.000000, 969.000000) translate(20.000000, 186.000000) translate(84.530330, 12.765165) scale(1, -1) translate(-84.530330, -12.765165)" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>

                    </button>
                </div>
                <div class="order-detail-botto mt-4 mb-4"
                    *ngIf="orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.min_cases == '' && orderDetail.is_po_enable">
                    <div class="col-md-12" *ngIf=" orderDetail != undefined && orderDetail.items_count != '0'">
                        <form [formGroup]="pOForm">
                            <div class="small-title">Enter PO Number*</div>
                            <input type="text" class="form-control" formControlName="po_number" name="po_number"
                                placeholder="E.g. AYH127G" required maxlength="30">
                            <div *ngIf="submitted && pOForm.controls.po_number?.errors" class="error">
                                <div *ngIf="pOForm.controls.po_number.errors?.required"><img
                                        src="/assets/images/error.svg" /> Please enter a PO number to complete the order
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div *ngIf="orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.min_cases == ''"
                    class="place-order">
                    <a href="javascript:void(0)"
                        (click)="placeOrder(global_data.card_payment, '', true, commonTemplateFor24HrPopup)"
                        title="Place Order"></a>
                    <ul>
                        <li>
                            <p>Place Order</p>
                            <span>{{orderDetail.items_count}}<span *ngIf="orderDetail.items_count == '1'"> item</span>
                                <span *ngIf="orderDetail.items_count != '1'"> items</span> , {{orderDetail.items_qty}}
                                <span *ngIf="orderDetail.items_qty == '1'"> Case</span>
                                <span *ngIf="orderDetail.items_qty != '1'"> Cases</span>
                            </span>
                        </li>
                        <li>
                            <img src="../../assets/images/forward-icon.svg" alt="place order">
                        </li>
                    </ul>
                </div>
                <div *ngIf=" orderDetail != undefined && orderDetail.items_count != '0' && orderDetail.min_cases != ''">

                    <p class="minimum-warning">{{orderDetail.min_cases_msg}}</p>
                </div>


            </div>
        </div>


    </div>
</div>

<ng-template #commonTemplateFor24HrPopup>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p style="white-space: pre-wrap">{{popupMessage}} </p>
                </div>
                <div class="button-div text-center mt-3 align-items-center">
                    <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
                    <button class="common-button mr-3"
                        (click)="placeOrder(global_data.card_payment, '', false, commonTemplateFor24HrPopup)">{{commonBottonText}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>